import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {ForecastDaysMode} from '@/app/constants/forecast';
import {useLocalizer} from '@/common/services/localizer';
import {selectDomainConfig} from '@/app/store/config/selectors';
import {selectForecastData, selectForecastViewParams} from '@/app/store/forecast/selectors';
import styles from './WeatherPageHiddenHeader.css';

export const WeatherPageHiddenHeader = memo(() => {
	const {location, extra} = useSelector(selectForecastData)!;
	const {daysMode, selectedWeekday, selectedDate} = useSelector(selectForecastViewParams);
	const {domainName} = useSelector(selectDomainConfig);

	const t = useLocalizer();

	let header;
	if (extra.type === 'mainPage') {
		header = t(`weatherHeaderMainPage.${domainName}`);
	} else if (daysMode === ForecastDaysMode.Days10 && selectedDate) {
		const locale = t.language;
		let dateOptions: Intl.DateTimeFormatOptions | undefined;
		if (locale === 'en') {
			dateOptions = {day: 'numeric', month: 'short', year: 'numeric'};
		}
		const date = new Date(selectedDate).toLocaleDateString(locale, dateOptions);
		header = t('weatherHeader10DaysDate', {locationLc: location.titleLc, date});
	} else if (daysMode === ForecastDaysMode.Days10) {
		header = t('weatherHeader10Days', {locationLc: location.titleLc});
	} else if (selectedWeekday !== undefined) {
		header = t('weatherHeader7DaysDate', {
			locationLc: location.titleLc,
			weekday: t(`weatherHeader7DayOptions.${selectedWeekday}`),
		});
	} else {
		header = t('weatherHeader7Days', {
			location: location.title,
			locationLc: location.titleLc,
			country: location.superior.country?.title || '',
		});
	}

	return (
		<div className={styles.root}>
			<h1>{header}</h1>
		</div>
	);
});

WeatherPageHiddenHeader.displayName = 'WeatherPageHiddenHeader';
